<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <CRUDList
        ref="crudList"
        :canAdd="false"
        :canEdit="false"
        :canSave="false"
        :showSelect="false"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :showDialog="false"
        :headers="headers"
        :headersWithColsSpan="headersWithColsSpan"
        :selectedItems="selectedItems"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="defaultSortBy"
        tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='370'
        @emitSelectedItem="emitSelectedItem"
        @loadCRUDList="loadBillRequest"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
        >
      </CRUDList>
    </v-col>
    <v-col cols="4">
      <MtgCoBillRequestsSideBar
       :baseCrudKey="baseCrudKey"
       @loadCRUDList="loadBillRequest"/>
    </v-col>
  </v-row>
  <MtgCoBillRequestsFooter
  :baseCrudKey="baseCrudKey"
  @loadCRUDList="loadBillRequest"
   />
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import MtgCoBillRequestsSideBar from './MtgCoBillRequestsSideBar.vue';
import MtgCoBillRequestsFooter from './MtgCoBillRequestsFooter.vue';
import { MtgBillRequestsHeaders, MtgBillRequestsHeadersTwo } from
  './MortgageCoProcessingUtils/MortgageCoProcessing.utils';
import { defaultGridLoading, manageGridLoading, pIdFormat } from '../../../util/shared/vue-global';
import '../../../assets/style.css';

export default {
  name: 'MtgCoBillRequestsList',
  components: {
    CRUDList,
    MtgCoBillRequestsSideBar,
    MtgCoBillRequestsFooter,
  },
  data() {
    return {
      baseCrudKey: 'MtgCoBillRequestsList',
      headers: MtgBillRequestsHeaders,
      headersWithColsSpan: MtgBillRequestsHeadersTwo,
      gridLoading: defaultGridLoading(),
    };
  },
  created() {
    this.funcCallWhenCreated();
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.MortgageCoProcessing.selectedMortgageCompanyPaymentsItems,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
    ]),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setMortgageCompanyPaymentsItems(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('tax/MortgageCoProcessing', [
      'setMortgageCompanyPaymentsItems',
    ]),
    ...mapActions('tax/MortgageCoProcessing', [
      'loadMtgBillRequestsRecords',
      'loadResultsCounts',
    ]),
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    ...mapActions('SystemConfig', ['loadConfig']),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    loadBillRequest(misMatchedRecords = false, mismatchAndRecWithMtgCode = false) {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState, misMatchedRecords, mismatchAndRecWithMtgCode };
      criteria.mtgCodeMulti = [];
      criteria.taxYear = this.latestTaxYear;
      manageGridLoading(this, true, 'Searching...');
      this.loadResultsCounts();
      this.loadMtgBillRequestsRecords({
        criteria,
        baseCrudKey,
        postProcessTrans: this.postProcessBillRequestData,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    postProcessBillRequestData(billRequests) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const processedData = billRequests.map((billRequest) => ({
        ...billRequest,
        propertyOrParcelId: pIdFormat(billRequest.propertyOrParcelId, formatPidPositions),
        taxId: billRequest.taxId,
      }));
      return processedData;
    },
    async funcCallWhenCreated() {
      this.loadConfig({ requiredScope: 'taxConfig' });
      await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
    },
  },
};
</script>
